<template>
  <div>
    
    <div class="btn-group" role="group" v-if="propEnabledDate">
      <button type="button" data-toggle="modal" :data-target="'#' + idDialog" class="btn btn-sm btn-light" aria-expanded="false">
        <small>Dia<br /></small>
        {{value.dia == 0 ? "-" : value.dia}}
      </button>
      <button  data-toggle="modal" type="button" :data-target="'#' + idDialog" class="btn btn-sm btn-light" aria-expanded="false">
        <small>Mês<br /></small>
        {{value.mes}}
      </button>
      <button type="button" data-toggle="modal" :data-target="'#' + idDialog" class="btn btn-sm btn-light" aria-expanded="false">
        <small>Ano<br /></small>
        {{value.ano}}
      </button>        
    </div>

    <div class="btn-group" role="group" style="margin-left:10px" v-if="propEnabledExportar">
      <button type="button" @click="$emit('export');" class="btn btn-sm btn-light" aria-expanded="false">
        <small>Exportar<br /></small>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-save2" viewBox="0 0 16 16">
          <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"/>
        </svg>        
      </button>            
    </div>
    
    <div class="btn-group" role="group" style="margin-left:10px">
      <button type="button" @click="$emit('reload');" class="btn btn-sm btn-light" aria-expanded="false">
        <small>Atualizar<br /></small>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
          <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
        </svg>     
      </button>            
    </div>
    
    <Dialog :id="idDialog" titulo="Data" ref="dialog" :modal="true" :hideCloseButton="true">
      <h5 style="margin-bottom:3px;">Dia</h5>
      <div>
          <button
            type="button"
            class="btn btn-sm"
            style="margin-top:5px;zoom:75%"
            :class="{'btn-outline-primary':0 !== value.dia,'btn-primary':0 === value.dia}"
            @click="value.dia=0"
            >Todos</button>
      </div>
      <div class="d-flex justify-content-center">
        <div class="d-flex justify-content-center flex-wrap" style="margin-left:5px;max-width:400px">
          <div style="margin-right:5px;" v-for="dia in 31" :key="dia" :item="dia">
            <button
              type="button"
              class="btn btn-sm"
              :class="{'btn-outline-primary':dia !== value.dia,'btn-primary':dia == value.dia}"
              @click="value.dia=dia"
              style="margin-top:5px;zoom:75%;min-width:40px"
              >{{dia}}</button>
          </div>
        </div>
      </div>
      <h5 style="margin-top:10px;margin-bottom:3px;">Mês</h5>
      <div class="d-flex justify-content-center" style="margin-left:5px">
        <div style="margin-right:5px" v-for="mes in 12" :key="mes" :item="mes">
          <button
            type="button"
            class="btn btn-sm"
            :class="{'btn-outline-primary':mes !== value.mes,'btn-primary':mes == value.mes}"
            @click="value.mes=mes"
            style="margin-top:5px;zoom:75%;min-width:40px"
            >{{mes}}</button>
        </div>
      </div>
      <h5 style="margin-top:10px;margin-bottom:3px;">Ano</h5>
      <div class="d-flex justify-content-center" style="margin-left:5px">
        <div style="margin-right:5px" v-for="ano in 4" :key="ano" :item="ano">
          <button
            type="button"
            class="btn btn-sm"
            :class="{'btn-outline-primary':ano + 2019 !== value.ano,'btn-primary':ano + 2019 == value.ano}"
            @click="value.ano=ano+2019"
            style="margin-top:5px;zoom:75%"
            >{{ano+2019}}</button>
        </div>
      </div>
      <template v-slot:rodape>
          <button type="button" data-dismiss="modal" class="btn btn-sm btn-secondary" @click="onChange()">Filtrar</button>
        </template>
    </Dialog>

  </div>
</template>

<script>
import Dialog from "./Dialog.vue";
import util from "../includes/util.js";

export default {
  name: "DataFiltro",
  components: {Dialog},
  props: {
    value: { type: Object, default: function(){return {dia:0,mes:0,ano:0}} },
    propEnabledExportar: { type: Boolean, default: false},
    propEnabledDate:{ type: Boolean, default: true},
    erro: { type: Boolean, default: false },
  },
  data() {
    return { 
      //idDialog: "" + guidGenerator()
      idDialog:""
    }
  },
  methods: {
    onChange()
    {
      this.$emit("change");
    },
  },
  mounted(){

    this.idDialog = "dialogDataFiltro_" + util.guidGenerator();
    
  }
};
</script>

<style>
</style>